import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { handleGenerateBrandUrl, handleGenerateProductLinkProps } from "@faire/retailer-visitor-shared/components/Carousel/utils";
import { CarouselBase } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { IconTextTile } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Components/IconTextTile";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { getAltTag } from "@faire/retailer-visitor-shared/features/Marketplace/utils";
import { ProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTile";
import { ProductTileType } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTileType";
import { MarketplaceProduct } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/MarketplaceProduct";
import { ILeanProductWithBrandTile } from "@faire/retailer-visitor-shared/lib/ILeanProductWithBrandTile";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSettingLayoutElementComposableTile } from "@faire/retailer-visitor-shared/settings/useSettingLayoutElementComposableTile";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import React from "react";
import { useLocation } from "react-router-dom";
export var ProductWithBrandCarousel = function(props) {
    var location = useLocation();
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _React_useContext = React.useContext(Context), layoutElement = _React_useContext.layoutElement, requestId = _React_useContext.requestId, onItemClick = _React_useContext.onItemClick, onCTAClick = _React_useContext.onCTAClick, onVisible = _React_useContext.onVisible, pageType = _React_useContext.pageType;
    var handleOnProductClick = function(product) {
        return function() {
            var _layoutElement_on_click_event_name, _product_token;
            onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId, (_product_token = product === null || product === void 0 ? void 0 : product.token) !== null && _product_token !== void 0 ? _product_token : "");
        };
    };
    var handleOnBrandClick = function(brand) {
        return function() {
            var _layoutElement_on_click_event_name, _brand_token;
            onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId, (_brand_token = brand === null || brand === void 0 ? void 0 : brand.token) !== null && _brand_token !== void 0 ? _brand_token : "");
        };
    };
    var isLoggedIn = useIsLoggedInRetailer();
    var useComposableTileOnLayoutElement = useSettingLayoutElementComposableTile();
    var renderItem = function(data, index) {
        var _tile_brand, _tile_product_product, _tile_product, _tile_product1, _tile_product_product1, _tile_product2, _tile_brand1, _tile_product_product2, _tile_product3;
        //render icon text tile
        if (data.icon_text_tile) {
            return /*#__PURE__*/ _jsx(IconTextTile, {
                iconTextLayoutElementData: data.icon_text_tile,
                onCTAClick: function() {
                    var _layoutElement_on_click_event_name;
                    onCTAClick === null || onCTAClick === void 0 ? void 0 : onCTAClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId);
                }
            }, "icon-text-tile-" + index);
        }
        var tile = ILeanProductWithBrandTile.fromLayoutElementData(data, strictLocalize);
        var useComposableTile = isLoggedIn && useComposableTileOnLayoutElement;
        if (!tile) {
            return null;
        }
        if (tile.product) {
            var _tile_product_product3, _layoutElement_tile_badges_map;
            var _tile_product_product_token;
            /**
             * While majority of carousels add the badge_list directly to the product,
             * we are populating the tile_badges_map on the BE for certain carousels. We have to associate
             * the badge with the product here in those cases, otherwise it uses the product
             * badge_list by default.
             */ var badgeFromMap = (_layoutElement_tile_badges_map = layoutElement.tile_badges_map) === null || _layoutElement_tile_badges_map === void 0 ? void 0 : _layoutElement_tile_badges_map[(_tile_product_product_token = (_tile_product_product3 = tile.product.product) === null || _tile_product_product3 === void 0 ? void 0 : _tile_product_product3.token) !== null && _tile_product_product_token !== void 0 ? _tile_product_product_token : ""];
            if (badgeFromMap) {
                tile.product.badge_list = badgeFromMap;
            }
        }
        if (useComposableTile) {
            return /*#__PURE__*/ _jsx(ProductTile, {
                productTile: tile.product,
                brand: tile.brand,
                productTileType: ProductTileType.LAYOUT_ELEMENT
            });
        }
        return /*#__PURE__*/ _jsx(MarketplaceProduct, {
            recordAdImpression: props.recordAdImpression,
            productTile: tile.product,
            brand: tile.brand,
            generateProductLinkProps: handleGenerateProductLinkProps(tile.product, location, props.productPageQueryParams),
            generateBrandUrl: handleGenerateBrandUrl((_tile_brand = tile.brand) === null || _tile_brand === void 0 ? void 0 : _tile_brand.token, (_tile_product = tile.product) === null || _tile_product === void 0 ? void 0 : (_tile_product_product = _tile_product.product) === null || _tile_product_product === void 0 ? void 0 : _tile_product_product.token),
            onClick: handleOnProductClick((_tile_product1 = tile.product) === null || _tile_product1 === void 0 ? void 0 : _tile_product1.product),
            onBrandClick: handleOnBrandClick(tile.brand),
            showVerticalImagery: layoutElement.show_vertical_imagery,
            altTag: getAltTag({
                productName: (_tile_product2 = tile.product) === null || _tile_product2 === void 0 ? void 0 : (_tile_product_product1 = _tile_product2.product) === null || _tile_product_product1 === void 0 ? void 0 : _tile_product_product1.name,
                brandName: (_tile_brand1 = tile.brand) === null || _tile_brand1 === void 0 ? void 0 : _tile_brand1.name,
                pageType: pageType
            }, strictLocalize)
        }, (_tile_product3 = tile.product) === null || _tile_product3 === void 0 ? void 0 : (_tile_product_product2 = _tile_product3.product) === null || _tile_product_product2 === void 0 ? void 0 : _tile_product_product2.token);
    };
    var getItems = function() {
        return layoutElement.layout_element_data.filter(isNotUndefined);
    };
    var onItemsVisible = function(items) {
        var itemTokens = items.map(function(item) {
            var _tile_product_product, _tile_product;
            var tile = ILeanProductWithBrandTile.fromLayoutElementData(item, strictLocalize);
            return tile === null || tile === void 0 ? void 0 : (_tile_product = tile.product) === null || _tile_product === void 0 ? void 0 : (_tile_product_product = _tile_product.product) === null || _tile_product_product === void 0 ? void 0 : _tile_product_product.token;
        });
        if (layoutElement.on_click_event_name) {
            var _itemTokens_join;
            onVisible === null || onVisible === void 0 ? void 0 : onVisible(layoutElement.on_click_event_name, requestId, (_itemTokens_join = itemTokens === null || itemTokens === void 0 ? void 0 : itemTokens.join(" ")) !== null && _itemTokens_join !== void 0 ? _itemTokens_join : "");
        }
    };
    return /*#__PURE__*/ _jsx(CarouselBaseComponent, _object_spread({
        renderItem: renderItem,
        items: getItems(),
        peekNextPercent: {
            mobileAndAbove: 20,
            tabletAndAbove: 0
        },
        lateralPadding: 16,
        onItemsVisible: onItemsVisible
    }, props));
};
var CarouselBaseComponent = CarouselBase;
